import styles from "./WhyChooseHealthcare.module.scss";
import Image from "next/image";
import cn from "clsx";
import WhyChooseMbaCard from "@/components/molecules/WhyChooseMbaCard/WhyChooseMbaCard";
import { addStaticSubdomain } from "@/revamp/molecules/ProgramCard/utils";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import formatTrademarkSymbols from "@/helpers/formatTrademarkSymbols";

const WhyChooseHealthcare = ({ WhyChooseMbaHealthcare }) => {
    const { Title, Subtitle, Logos, rightImagelist } = WhyChooseMbaHealthcare;
    return (
        <section className={styles.root} id="program_overview">
            <div className={styles.content_wrapper}>
                <div className={styles.lhs}>
                    <h2
                        className={styles.content_heading}
                        dangerouslySetInnerHTML={{
                            __html: formatTrademarkSymbols(Title)
                        }}
                    />
                    <div
                        className={cn(styles.content_desc, "mt-2")}
                        dangerouslySetInnerHTML={{
                            __html: formatTrademarkSymbols(Subtitle)
                        }}
                    />
                    {
                        (Logos?.length > 0) && (
                            <div className="flex sm:px-4 p-0 lg:mt-4">
                                <Carousel
                                    config={{
                                        spaceBetween: 12,
                                        slidesPerView: 2,
                                        breakpoints: {
                                            320: {
                                                slidesPerView: 2.5,
                                                spaceBetween: 5,
                                            },
                                            400: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            520: {
                                                slidesPerView: 3,
                                                spaceBetween: 12,
                                            },
                                            1024: {
                                                slidesPerView: 4,
                                                spaceBetween: 5,
                                            },
                                            1201: {
                                                slidesPerView: 5,
                                                spaceBetween: 15,
                                            }
                                        },
                                    }}
                                    className={`${styles.whyChooseHealthCareWrapper} relative`}
                                    slidesContainerClassName={styles.slidesContainer}
                                    slideWrapperClassName={styles.slideWrapper}
                                    isSmoothBehaviour={true}
                                    id="WhyChooseCPM"
                                >
                                    {Logos?.map((item, ind) => {
                                        return (
                                            <div key={ind} className={cn(styles.content_img_container, Logos?.length === 1 && styles.img_container2)}>
                                                <img
                                                    src={addStaticSubdomain(item)}
                                                    alt={"amity online"}
                                                    height={184}
                                                    width={184}
                                                    className={styles.cardImg}
                                                />
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            </div>
                        )
                    }
                </div>
                <div className={cn(styles.rhs, styles.mh_28)}>
                    {
                        rightImagelist?.map((item, index) => {
                            return (
                                <WhyChooseMbaCard
                                    data={item}
                                    key={index}
                                />
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default WhyChooseHealthcare